import { SEARCH_PHOTOS } from "../constants/type";

import Api from "../utils/api";
import { EndPoints } from "../constants/endpoints";

export const search = (param) => {
  return (dispatch) => {
    return {
      type: SEARCH_PHOTOS,
      payload: () => {
        return Api.get(EndPoints.photos(), param);
      },
    };
  };
};
